export default __webpack_public_path__ + "ff5fc93f1c79be2a8f6f1c8d197fa2c5.png";